export default __webpack_public_path__ + "static/media/News-3.24dfe952.jpg";